﻿import {SupplierSortByHookTypes} from "../../types/SupplierSortByHookTypes";
import {useEffect} from "react";
import _ from "underscore";
import {Supplier} from "../../types/Supplier";

const useSupplierSortByDailyRateHigh = ({ searchSortBy, unsortedSuppliers, sortedSuppliersSetter }: SupplierSortByHookTypes) => {
  useEffect(() => {
    if (searchSortBy === 'daily-rate-high' && unsortedSuppliers.length) {
      sortedSuppliersSetter(_.sortBy(unsortedSuppliers, (supplier: Supplier) => supplier?.pricePerDay || -Infinity).reverse());
    }
  }, [searchSortBy, sortedSuppliersSetter, unsortedSuppliers]);
}

export { useSupplierSortByDailyRateHigh };
